import axios from "@util/axios.js";
import projectConfig from "@projectConfig";
import { sha512 } from "js-sha512";

const { hostCloud } = projectConfig.api;

export const createCart = async (shopId) => {
   const body = { shopId, lang: "pl", operation: "create" };
   const url = `${hostCloud}/legacy/request`;
   const data = {
      endpoint: `/shop/method/cart`,
      httpMethod: "POST",
      isAuthenticated: true,
      body: JSON.stringify(body)
   };
   return await axios({
      method: "post",
      url,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json"
      },
      data: data
   });
};

export const postCart = async (shopId, cartId, itemId, quantity, operation) => {
   const HEADER = '{"typ":"signature"}';
   const PAYLOAD = `{"timestamp":${Date.now()}}`;
   const signature = sha512
      .hmac(process.env.REACT_APP_LIST_DATA, `${HEADER}.${PAYLOAD}`)
      .toLowerCase();
   const legacyToken = `${btoa(HEADER)}.${btoa(PAYLOAD)}.${btoa(signature)}`;
   const url = `${hostCloud}/legacy/request`;
   const body = {
      shopId,
      lang: "PL",
      operation,
      cart: cartId,
      cartItem: {
         id: itemId,
         quantity,
         unit: "szt."
      }
   };
   const data = {
      endpoint: `/shop/method/cart`,
      httpMethod: "POST",
      isAuthenticated: true,
      body: JSON.stringify(body)
   };
   return await axios({
      method: "post",
      url,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
         Authorization: legacyToken
      },
      data: data
   });
};